import React from 'react';
export const Footer = () => {
  return <footer className="bg-offwhite border-t border-beige" data-id="element-101">
      <div className="max-w-6xl mx-auto px-6 py-12" data-id="element-102">
        {/* Top: logo + nav links */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8" data-id="element-103">
          <div className="flex items-center gap-2" data-id="element-104">
            <div className="w-6 h-6 rounded-full bg-sage flex items-center justify-center" data-id="element-105">
              <div className="w-2 h-2 rounded-full bg-offwhite" data-id="element-106" />
            </div>
            <span className="font-serif font-medium text-lg text-navy" data-id="element-107">
              Консилиум
            </span>
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-navyLight" data-id="element-108">
            <a href="#/privacy" className="hover:text-sage transition-colors" data-id="element-109">
              Политика конфиденциальности
            </a>
            <a href="mailto:info@2opinion-online.ru" className="hover:text-sage transition-colors" data-id="element-110">
              info@2opinion-online.ru
            </a>
          </div>
        </div>

        {/* Disclaimer + requisites — quiet, single block */}
        <div className="text-xs text-navyLight/60 text-center md:text-left leading-relaxed border-t border-beige pt-6 space-y-2" data-id="element-111">
          <p data-id="element-112">
            Сервис предоставляет информационно-аналитические услуги по
            экспертной оценке медицинской документации («Второе мнение»).
            Эксперты анализируют предоставленные документы, формируют экспертные
            мнения и объясняют возможные варианты простым языком.
          </p>
          <p data-id="element-113">
            Услуга{' '}
            <strong className="font-medium text-navyLight/80" data-id="element-114">
              не является
            </strong>{' '}
            медицинским диагнозом, назначением лечения или заменой очной
            консультации лечащего врача. Окончательное клиническое решение
            принимаете вы совместно с вашим лечащим врачом.
          </p>
          <p className="text-navyLight/50" data-id="element-115">
            ИП Федин Андрей Дмитриевич · ИНН 590310476707 ·{' '}
            <a href="mailto:info@2opinion-online.ru" className="hover:text-sage transition-colors" data-id="element-116">
              info@2opinion-online.ru
            </a>
            {' · '}
            <a href="https://2opinion-online.ru" className="hover:text-sage transition-colors" data-id="element-117">
              2opinion-online.ru
            </a>
          </p>
          <p className="text-navyLight/50" data-id="element-118">
            Обработка персональных данных — в соответствии с ФЗ № 152-ФЗ.{' '}
            <a href="#/privacy" className="hover:text-sage transition-colors underline" data-id="element-119">
              Политика
            </a>
            . © {new Date().getFullYear()} ИП Федин А.Д.
          </p>
        </div>
      </div>
    </footer>;
};